import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LoadingStatus } from 'src/app/core/domain/events/state_provider';
import { Dietitian } from 'src/app/data/dietitian/domain/dietitian';
import { DietitianStateProvider } from 'src/app/data/dietitian/domain/dietitian_state_provider';

import { TrackerCommands } from '../../../../data/tracker/domain/tracker/tracker_commands';

export interface CustomTrackersViewModel {
  isLoading: boolean;
  error: string;
  dietitian: Dietitian;
}

@Injectable()
export class CustomTrackersFacade {
  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private trackerCommands: TrackerCommands,
  ) {
    // do nothing
  }

  get dashboardStatus$(): Observable<CustomTrackersViewModel> {
    return this.dietitianStateProvider.state$.pipe(
      map((e) => {
        return <CustomTrackersViewModel>{
          isLoading: e.loading == LoadingStatus.LOADING,
          error: e.loading == LoadingStatus.ERROR ? e.message : undefined,
          dietitian: e.entity,
        };
      }),
    );
  }

  async updateWithCustomTracker(dietitian: Dietitian | undefined) {
    if (dietitian) {
      return await this.trackerCommands.updateCustomTrackers(
        dietitian.dietitianId.id.toString(),
      );
    }
    throw new Error('Diététicien.ne non identifié.e !');
  }
}
